import jsCookie from 'js-cookie'
import _getValue from 'lodash/get'
import { viewImage, openLink, isLeYou } from './utils/utils'
import { BUZZTYPE } from '@/utils/constants'
import { Base64 } from 'js-base64'

export default function install(Vue) {
  Vue.prototype.$cookie = jsCookie
  Vue.prototype.$viewImage = viewImage
  Vue.prototype.$openLink = openLink
  Vue.prototype.$getValue = _getValue
  Vue.prototype.$BUZZTYPE = BUZZTYPE
  Vue.prototype.$isLeYou = isLeYou
  Vue.prototype.$base64 = Base64
}
